import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/models/api-response.model';
import { Pagination } from '@core/models/pagination.model';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { SiteDomain } from '@core/models/site-domain.model';

@Injectable()
export class SiteDomainDataService {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(private http: HttpClient) { }

  getAll(): Observable<SiteDomain[]> {
    return this.http.get<ApiResponse>('/sitedomain').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<SiteDomain[]>{
    return this.http.get<ApiResponse>(`/sitedomain${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getById(id: number): Observable<SiteDomain>{
    return this.http.get<ApiResponse>(`/sitedomain/${id}`).pipe(
      map(res => res.data)
    );
  }

  add(data: SiteDomain): Observable<SiteDomain> {
    return this.http.post<ApiResponse>(`/sitedomain`, data).pipe(
      tap(res => this.messages$.next(res.message)),
      map(res => res.data.rows)
    );
  }

  update(id: number, data: SiteDomain) {
    return this.http.put<ApiResponse>(`/sitedomain/${id}`, data).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if (res) {
      this.pagination = res.data.paginations;
    }
  }
}
